'use client';
import React from 'react';
import { useState, useRef } from 'react';
import SafeLink from '@/components/SafeLink';
import styles from './style.module.scss';
import { EXPOSURE_RECORD, sendClickTrack } from '@/tracks/32401';

export const MiniHomeClient = ({ homeList }: { homeList: any[] }) => {
  const showMiniTab = !!homeList?.length;

  // 拖拽滑动相关
  const containerRef = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  // 防止拖动时触发tab点击
  const dragActiveRef = useRef(false);

  // 鼠标事件处理
  const onMouseDown = (e: React.MouseEvent) => {
    if (containerRef.current) {
      setIsDragging(true);
      setStartX(e.pageX);
      setScrollLeft(containerRef.current.scrollLeft);
      dragActiveRef.current = false;
    }
  };

  const onMouseMove = (e: React.MouseEvent) => {
    if (!isDragging || !containerRef.current) return;
    const dx = e.pageX - startX;
    if (Math.abs(dx) > 3) dragActiveRef.current = true; // 超过3px算拖动，阻止点击
    containerRef.current.scrollLeft = scrollLeft - dx;
  };

  const onMouseUp = () => {
    setIsDragging(false);
    setStartX(0);
    setScrollLeft(0);
    setTimeout(() => {
      dragActiveRef.current = false;
    }, 100);
  };

  // 鼠标离开容器时也停止拖动
  const onMouseLeave = () => {
    setIsDragging(false);
    setStartX(0);
    setScrollLeft(0);
    setTimeout(() => {
      dragActiveRef.current = false;
    }, 100);
  };
  if (!showMiniTab) {
    return null;
  }

  return (
    <div className={styles['uk-miniHome']}>
      <div
        className={styles.homeContainer}
        ref={containerRef}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseLeave}
        style={{ cursor: isDragging ? 'grabbing' : 'grab', userSelect: 'none' }} // 拖动时改变鼠标样式
      >
        {homeList.map((item: any, index: number) => (
          <div
            className={styles.tab}
            key={item.tabName}
            exptag={'exp|' + EXPOSURE_RECORD.Home_Mini_Hp_Tab_Expo}
            data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
            data-exptag-json-param={JSON.stringify({
              index: index,
              Mini_Hp_Name: item.jumpLink?.jumpValue.pageCodeInfo?.pageName || 'home',
            })}
            onClick={(e) => {
              if (dragActiveRef.current) {
                e.preventDefault();
                e.stopPropagation();
                return;
              }
              sendClickTrack.Home_Mini_Hp_Tab({
                index: index,
                Mini_Hp_Name: item.jumpLink?.jumpValue.pageCodeInfo?.pageName || 'home',
              });
            }}
          >
            <SafeLink
              href={
                item.jumpLink?.jumpType === 'mini-home'
                  ? `/minihome/${item.jumpLink.jumpValue.pageCodeInfo?.pageCode}`
                  : item.jumpLink?.jumpType === 'custom'
                    ? item.jumpLink?.jumpValue.link
                    : {}
              }
              style={item.highLight ? { color: item.highLight } : undefined}
            >
              <p>{item.tabName}</p>
            </SafeLink>
          </div>
        ))}
      </div>
    </div>
  );
};
